import { throwError as observableThrowError, Observable, of } from 'rxjs';
import { Router } from '@angular/router';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { CookieService } from 'ngx-cookie';
import { map, catchError, mergeMap } from 'rxjs/operators';
import { RtbAuthService } from '../auth/rtb-auth.service';

export class HttpService {

  private static COOKIE_KEY_ID_TOKEN_EXPIRE = 'id_token_expire';
  private static COOKIE_KEY_ID_TOKEN = 'id_token';
  private static HTTP_HEADER_KEY_TIMEZONE = 'X-Client-Timezone';

  private _cookieService: CookieService;
  private _httpClient: HttpClient;
  private _router: Router;
  private _rtbAuthService: RtbAuthService;
  private appGatewayHost: string;
  private withCredentials: boolean;

  constructor(_authService: RtbAuthService) {
    this._rtbAuthService = _authService;
  }

  setCookieService(_cookieService: CookieService) {
    this._cookieService = _cookieService;
  }

  setHttpClient(_httpClient: HttpClient) {
    this._httpClient = _httpClient;
  }

  setRouter(_router: Router) {
    this._router = _router;
  }

  private getAppGatewayUrl(): string {
    return this.appGatewayHost + '/';
  }

  getWebEndopointForAuth(params: string[]): string {
    let endpoint = this.getAppGatewayUrl() + 'auth/';
    if (params) {
      params.forEach(param => {
        endpoint += param + '/';
      });
    }
    return endpoint;
  }

  getTimeZoneHeader(): HttpHeaders {
    const key = HttpService.HTTP_HEADER_KEY_TIMEZONE;
    const utc = new Date();
    const timeZoneOffset = (utc.getTimezoneOffset() / 60).toString();
    return new HttpHeaders({ [key]: timeZoneOffset });
  }

  getWithCredentialsOption(): boolean {
    return this.withCredentials;
  }

  handleErrorUnauthorized(error: HttpErrorResponse) {
    if (error && error.status === 401) {
      console.log('Unauthorized');
      // 認証有効期限切れのためログアウト
      window.location.href = this.getWebEndopointForAuth(['logout']);
      this._rtbAuthService.logout();
    }
  }

  getAuthorizationIdToken(): Observable<string> {
    let cookieIdToken = this._cookieService.get(HttpService.COOKIE_KEY_ID_TOKEN);
    const cookieIdTokenExpired = this._cookieService.get(HttpService.COOKIE_KEY_ID_TOKEN_EXPIRE);
    if (cookieIdToken && cookieIdTokenExpired) {
      if (this.validateAccessIdTokenExpired(cookieIdTokenExpired)) {
        // idTokenが有効
        return of(this._cookieService.get(cookieIdToken));
      } else {
        // idToken期限切れ時の処理
        return this.getAccessAndRefreshToken().pipe(mergeMap(() => {
          cookieIdToken = this._cookieService.get(HttpService.COOKIE_KEY_ID_TOKEN);
          if (cookieIdToken) {
            return of(this._cookieService.get(cookieIdToken));
          }
        }));
      }
    } else {
      // id_tokenが取得できない
      window.location.href = this.getWebEndopointForAuth(['logout']);
      this._rtbAuthService.logout();
      return observableThrowError('not authenticated.');
    }
  }

  private getAccessAndRefreshToken(): Observable<any> {
    // const endpoint = 'https://app.olympus-ims-dev.com/refresh-tokens';
    // return this._httpClient.get(endpoint, { withCredentials: this.getWithCredentialsOption() }).pipe(map(response => response),
    return this._rtbAuthService.refreshTokens().pipe(
      catchError(
        (err) => {
          window.location.href = this.getWebEndopointForAuth(['logout']);
          this._rtbAuthService.logout();
          return observableThrowError(err.json().error || 'backend server error');
        }
      ));
  }

  private validateAccessIdTokenExpired(cookieIdTokenExpire: string): boolean {
    try {
      const idTokenExpired = parseInt(cookieIdTokenExpire, 10);
      const nowUnixTime = Math.floor(new Date().getTime() / 1000);
      if (nowUnixTime < idTokenExpired) {
        return true;
      }
    } catch (e) {
      console.log(e);
    }
    return false;
  }
}
